(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card-color-selector"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('product-card-color-selector')) return;

  class ProductCardColorSelector extends HTMLElement {
    constructor() {
      super();
      this.onToggleClick = this.onToggleClick.bind(this);
      this.onSwatchChange = this.onSwatchChange.bind(this);
      this.onSwatchClick = this.onSwatchClick.bind(this);
      this.onDocumentClick = this.onDocumentClick.bind(this);
      this.selectedOptions = [];
      this.variants = [];
      this.colorIndex = 0;
      this.hasOtherOptions = false;
      this.imagesPreloaded = false;
    }

    connectedCallback() {
      this.card = this.closest('.js-product-card');
      this.toggleButton = this.querySelector('.js-product-card-color-toggle');
      this.swatchGroup = this.querySelector('.js-product-card-color-swatches');
      this.colorIndex = parseInt(this.dataset.colorIndex, 10) || 0;
      this.hasOtherOptions = this.dataset.hasOtherOptions === 'true';
      this.variants = this.parseVariants();

      const selectedVariant = this.findVariantById(this.dataset.selectedVariantId);
      this.selectedOptions = selectedVariant
        ? selectedVariant.options.slice()
        : [];

      this.toggleButton?.addEventListener('click', this.onToggleClick);
      this.swatchGroup?.addEventListener('change', this.onSwatchChange);
      this.swatchGroup?.addEventListener('click', this.onSwatchClick);
      document.addEventListener('click', this.onDocumentClick);

      this.applyVariant(selectedVariant, { skipImage: true });
    }

    disconnectedCallback() {
      this.toggleButton?.removeEventListener('click', this.onToggleClick);
      this.swatchGroup?.removeEventListener('change', this.onSwatchChange);
      this.swatchGroup?.removeEventListener('click', this.onSwatchClick);
      document.removeEventListener('click', this.onDocumentClick);
    }

    parseVariants() {
      const script = this.querySelector('[data-product-card-variants]');
      if (!script) return [];
      try {
        return JSON.parse(script.textContent);
      } catch (error) {
        return [];
      }
    }

    findVariantById(id) {
      return this.variants.find((variant) => String(variant.id) === String(id));
    }

    findMatchingVariant(options) {
      const exactMatch = this.variants.find((variant) =>
        variant.options.every((option, index) => option === options[index]),
      );
      if (exactMatch) return exactMatch;

      const colorValue = options[this.colorIndex];
      return (
        this.variants.find(
          (variant) =>
            variant.options[this.colorIndex] === colorValue && variant.available,
        ) ||
        this.variants.find(
          (variant) => variant.options[this.colorIndex] === colorValue,
        )
      );
    }

    onToggleClick(event) {
      event.preventDefault();
      event.stopPropagation();
      this.preloadImages();
      this.toggleOpen(!this.classList.contains('is-open'));
    }

    onDocumentClick(event) {
      if (!this.classList.contains('is-open')) return;
      if (this.contains(event.target)) return;
      if (event.target.closest('.js-product-card-add-to-cart')) return;
      this.toggleOpen(false);
    }

    toggleOpen(isOpen) {
      if (isOpen) {
        document.querySelectorAll('product-card-color-selector.is-open').forEach((el) => {
          if (el !== this) el.toggleOpen(false);
        });
      }

      this.classList.toggle('is-open', isOpen);
      this.toggleButton?.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

      if (isOpen) {
        const selected = this.querySelector('.js-product-card-color-swatch:checked');
        selected?.focus();
      }
    }

    onSwatchChange(event) {
      const input = event.target.closest('.js-product-card-color-swatch');
      if (!input) return;
      this.selectColor(input);
    }

    onSwatchClick(event) {
      const label = event.target.closest('.product-card-color-selector__swatch-label');
      if (!label || !this.contains(label)) return;
      const input = label.querySelector('.js-product-card-color-swatch');
      if (!input || input.disabled) return;
      this.selectColor(input);
    }

    selectColor(input) {
      const colorValue = input.value;
      const nextOptions = this.selectedOptions.slice();
      nextOptions[this.colorIndex] = colorValue;

      const variant =
        this.findMatchingVariant(nextOptions) ||
        this.findVariantById(input.dataset.variantId);
      if (!variant) return;

      this.selectedOptions = variant.options.slice();
      this.dataset.selectedVariantId = String(variant.id);
      this.applyVariant(variant);
    }

    applyVariant(variant, options = {}) {
      if (!variant) return;

      this.updateAddToCart(variant);
      if (!this.card) return;
      this.updatePrice(variant);
      this.updateLinks(variant);
      if (!options.skipImage) this.updateImage(variant);
    }

    updateAddToCart(variant) {
      const variantId = String(variant.id);
      const available = variant.available ? 'true' : 'false';
      const button =
        this.card?.querySelector('[data-plp-add-to-bag], [data-quick-add-to-bag]') ||
        this.closest('.product-addToCartWrapper')?.querySelector(
          '[data-plp-add-to-bag], [data-quick-add-to-bag]',
        );

      if (button) {
        button.setAttribute('data-id', variantId);
        button.setAttribute('data-available', available);
        button.setAttribute('data-variantcount', '1');
      }

      const wrappers = new Set();
      const scope = this.card || this;
      const closestWrapper = this.closest('[data-plp-direct-add-variant-id]');
      const cardWrapper = scope.closest?.('[data-plp-direct-add-variant-id]');
      const productCard = scope.closest?.('.product-card') || this.closest('.product-card');
      if (closestWrapper) wrappers.add(closestWrapper);
      if (cardWrapper) wrappers.add(cardWrapper);
      if (productCard) wrappers.add(productCard);

      wrappers.forEach((wrapper) => {
        wrapper.setAttribute('data-plp-direct-add-variant-id', variantId);
        wrapper.setAttribute('data-plp-direct-add-available', available);
      });
    }

    updatePrice(variant) {
      const priceEl = this.card.querySelector('.js-product-card-price');
      const compareEl = this.card.querySelector('.js-product-card-compare-price');
      if (priceEl) {
        priceEl.textContent = variant.price;
        priceEl.classList.toggle('text-aqua-950', Boolean(variant.compare_at_price));
        priceEl.classList.toggle('text-griege-950', !variant.compare_at_price);
      }
      if (compareEl) {
        if (variant.compare_at_price) {
          compareEl.textContent = variant.compare_at_price;
          compareEl.classList.remove('hidden');
        } else {
          compareEl.classList.add('hidden');
        }
      }
    }

    updateLinks(variant) {
      if (!variant.url) return;
      this.card.querySelectorAll('.js-product-card-link').forEach((link) => {
        link.setAttribute('href', variant.url);
      });
    }

    updateImage(variant) {
      if (!variant.featured_image) return;
      if (this.card.querySelector('.js-product-card-swiper-container')) return;

      const img = this.card.querySelector('.js-product-card-image');
      if (!img || img.dataset.currentImage === variant.featured_image) return;

      const preload = new Image();
      preload.onload = () => {
        img.src = variant.featured_image;
        if (variant.featured_image_srcset) {
          img.srcset = variant.featured_image_srcset;
        }
        if (variant.featured_image_alt) {
          img.alt = variant.featured_image_alt;
        }
        img.dataset.currentImage = variant.featured_image;
      };
      preload.src = variant.featured_image;
    }

    preloadImages() {
      if (this.imagesPreloaded) return;
      this.imagesPreloaded = true;
      this.variants.forEach((variant) => {
        if (!variant.featured_image) return;
        const image = new Image();
        image.src = variant.featured_image;
      });
    }
  }

  customElements.define('product-card-color-selector', ProductCardColorSelector);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quick-add-direct-cart"] && !Shopify.designMode) return;
  try {
    const BUTTON_SELECTOR = '[data-quick-add-to-bag]';

  const cartRoot = () =>
    window.Shopify?.routes?.root || '/';

  const directAddToCart = async (variantId, contextEl) => {
    if (!variantId) return;
    if (
      contextEl?.classList.contains('processing') ||
      contextEl?.classList.contains('show-added')
    ) {
      return;
    }

    contextEl?.classList.add('processing');

    try {
      const response = await fetch(`${cartRoot()}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 }),
      });

      if (!response.ok) throw new Error('Failed to add product to cart');

      contextEl?.classList.add('show-added', 'initial-a2c-success');
      if (contextEl) {
        setTimeout(() => contextEl.classList.remove('show-added'), 2500);
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
    } finally {
      contextEl?.classList.remove('processing');
    }
  };

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest(BUTTON_SELECTOR);
      if (!button) return;

      const container = button.closest('[data-plp-quick-view-enabled]');
      if (!container || container.getAttribute('data-plp-quick-view-enabled') === 'true') {
        return;
      }

      const cardWrapper = button.closest('[data-plp-direct-add-variant-id]');
      const variantId =
        button.getAttribute('data-id') ||
        cardWrapper?.getAttribute('data-plp-direct-add-variant-id');
      if (!variantId) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const available =
        button.getAttribute('data-available') ||
        cardWrapper?.getAttribute('data-plp-direct-add-available');
      if (available === 'false') {
        alert('Product Sold Out!');
        return;
      }

      directAddToCart(variantId, button.closest('.product-addToCartWrapper'));
    },
    true,
  );
  } catch(e) { console.error(e); }
})();

})();
